// categoryDetailData.js
import { ASSETS } from "../assets/assets";

import {
  Pencil,
  Flag,
  Mountain,
  Clock,
  Cross,
  Trophy,
  Zap,
  Users,
} from "lucide-react";

export const categoryDetailData = {
  // ===================== 8 KM =====================
  "8": {
    title: "ATR 8 KM",

    summaryCards: [
      { Icon: Pencil, label: "REG FEE", value: "Local: 450.000 | Foreign: 2.000.000" },
      { Icon: Flag, label: "START", value: "Friday, 09 May 2025 | 08:00 AM" },
      { Icon: Mountain, label: "ELEVATION GAIN", value: "474 m" },
      { Icon: Clock, label: "CUT OFF TIME", value: "5 Hours" },
      { Icon: Cross, label: "WS & DROP BAG", value: "1 WS & 1 CP" },
      // { Icon: Trophy, label: "AWARD & PRIZE", value: "Open, Master 50+" },
    ],

    details: [
      { label: "Distance", value: "8 KM", Icon: Zap },
      { label: "Elevation Gain", value: "7.244 m", Icon: Mountain },
      { label: "Cut-Off Time", value: "34 Hours", Icon: Clock },
      { label: "Age Range", value: "18 - 50+", Icon: Users },
      // { label: "Award & Prize", value: "Open, Master 50+", Icon: Trophy },
    ],

    copData: [
      "COP 1 at WS4 / KM40 : 9 Hours",
      "COP 2 at WS6 / KM60 : 16 Hours",
      "COP 3 at WS8 / KM80 : 25 Hours",
    ],

    qualificationData: [
      "100K ultra road race",
      "BTRU 55K ultra trail",
      "60K - 80K ultra trail race",
    ],

    // 👉 AMBIL DARI assets.js
    bannerImageUrl: ASSETS.category8k,
    runnerIllustrationUrl: ASSETS.start,
    routeMapUrl: ASSETS.routemap,
  },

  // ===================== 18 KM =====================
  "18": {
    title: "ATR 18 KM",

    summaryCards: [
      { Icon: Pencil, label: "REG FEE", value: "Local: 700.000 | Foreign: 2.000.000" },
      { Icon: Flag, label: "START", value: "Friday, 09 May 2025 | 07:00 AM" },
      { Icon: Mountain, label: "ELEVATION GAIN", value: "1370 m" },
      { Icon: Clock, label: "CUT OFF TIME", value: "7 Hours" },
      { Icon: Cross, label: "WS & DROP BAG", value: "2 WS & 1 CP" },
      // { Icon: Trophy, label: "AWARD & PRIZE", value: "Open, Master 50+" },
    ],

    details: [
      { label: "Distance", value: "18 KM", Icon: Zap },
      { label: "Elevation Gain", value: "1370 m", Icon: Mountain },
      { label: "Cut-Off Time", value: "7 Hours", Icon: Clock },
      { label: "Age Range", value: "18 - 50+", Icon: Users },
      // { label: "Award & Prize", value: "Open, Master 50+", Icon: Trophy },
    ],

    copData: [
      "COP 1 at WS4 / KM40 : 9 Hours",
      "COP 2 at WS6 / KM60 : 16 Hours",
      "COP 3 at WS8 / KM80 : 25 Hours",
    ],

    qualificationData: [
      "100K ultra road race",
      "BTRU 55K ultra trail",
      "60K - 80K ultra trail race",
    ],

    bannerImageUrl: ASSETS.category16k,
    runnerIllustrationUrl: ASSETS.start,
    routeMapUrl: ASSETS.routemap,
  },

  // ===================== 32 KM =====================
  "32": {
    title: "ATR 32 KM",

    summaryCards: [
      { Icon: Pencil, label: "REG FEE", value: "Local: 850.000 | Foreign: 2.000.000" },
      { Icon: Flag, label: "START", value: "Friday, 09 May 2025 | 06:00 AM" },
      { Icon: Mountain, label: "ELEVATION GAIN", value: "2132 m" },
      { Icon: Clock, label: "CUT OFF TIME", value: "9 Hours" },
      { Icon: Cross, label: "WS & DROP BAG", value: "3 WS & 3 CP" },
      // { Icon: Trophy, label: "AWARD & PRIZE", value: "Open, Master 50+" },
    ],

    details: [
      { label: "Distance", value: "32 KM", Icon: Zap },
      { label: "Elevation Gain", value: "2132 m", Icon: Mountain },
      { label: "Cut-Off Time", value: "9 Hours", Icon: Clock },
      { label: "Age Range", value: "18 - 50+", Icon: Users },
      // { label: "Award & Prize", value: "Open, Master 50+", Icon: Trophy },
    ],

    copData: [
      "COP 1 at WS4 / KM40 : 9 Hours",
      "COP 2 at WS6 / KM60 : 16 Hours",
      "COP 3 at WS8 / KM80 : 25 Hours",
    ],

    qualificationData: [
      "100K ultra road race",
      "BTRU 55K ultra trail",
      "60K - 80K ultra trail race",
    ],

    bannerImageUrl: ASSETS.category32k,
    runnerIllustrationUrl: ASSETS.start,
    routeMapUrl: ASSETS.routemap,
  },

  // ===================== 50 KM =====================
  "50": {
    title: "ATR 50 KM",

    summaryCards: [
      { Icon: Pencil, label: "REG FEE", value: "Local: 1.000.000 | Foreign: 2.000.000" },
      { Icon: Flag, label: "START", value: "Friday, 09 May 2025 | 08:00 AM" },
      { Icon: Mountain, label: "ELEVATION GAIN", value: "3187 m" },
      { Icon: Clock, label: "CUT OFF TIME", value: "13 Hours" },
      { Icon: Cross, label: "WS & DROP BAG", value: "5 WS & Drop Bag at Hillside" },
      // { Icon: Trophy, label: "AWARD & PRIZE", value: "Open, Master 50+" },
    ],

    details: [
      { label: "Distance", value: "50 KM", Icon: Zap },
      { label: "Elevation Gain", value: "3187 m", Icon: Mountain },
      { label: "Cut-Off Time", value: "13 Hours", Icon: Clock },
      { label: "Age Range", value: "18 - 50+", Icon: Users },
      // { label: "Award & Prize", value: "Open, Master 50+", Icon: Trophy },
    ],

    copData: [
      "COP 1 at WS4 / KM40 : 9 Hours",
      "COP 2 at WS6 / KM60 : 16 Hours",
      "COP 3 at WS8 / KM80 : 25 Hours",
    ],

    qualificationData: [
      "100K ultra road race",
      "BTRU 55K ultra trail",
      "60K - 80K ultra trail race",
    ],

    bannerImageUrl: ASSETS.category50k,
    runnerIllustrationUrl: ASSETS.start,
    routeMapUrl: ASSETS.routemap,
  }
};
